module.exports = __webpack_public_path__ + "img/legacy-glow.3cf61fd9.png";